import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IRequestTypeAddPayload, IRequestTypeUpdatePayload } from './cerere-type.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class CerereTypeService {
  private serviceName = "CerereTypeService";

  private token!: string;
  private basePath = environment.interop.basePath;
  private httpOptions: any;
  private getRequestTypesDTUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .getCerereTypesDT;
  private storeRequestTypeUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .storeCerereType;
  private updateRequestTypeUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .putCerereType;
  private deleteRequestTypeUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .deleteCerereType;
  private getRequestTypesActiveUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .getCerereTypesActive;
  private getRequestTypesPublicUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .getCerereTypesActivePublic;

  private getListURL =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .getCerereTypes;

  private clearCacheUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
      .clearCache;

    private changeStatusActiveUrl =
      this.basePath +
      environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
        .changeStatusCerereTypeActive;
    private changeStatusPublicUrl =
      this.basePath +
      environment.interop.autorizatiiComerciale.nomenclatoare.cerereType
        .changeStatusCerereTypePublic;

  constructor(private http: HttpClient) {}

  getRequestTypesDT() {
    return this.http.get(this.getRequestTypesDTUrl, this.httpOptions);
  }

  getList() {
    return this.http.get(this.getListURL, this.httpOptions);
  }

  clearCache() {
    return this.http.get(this.clearCacheUrl, this.httpOptions);
  }

  addRequestType(data: IRequestTypeAddPayload) {
    return this.http.post(this.storeRequestTypeUrl, data, this.httpOptions);
  }

  updateRequestType(data: IRequestTypeUpdatePayload) {
    return this.http.put(this.updateRequestTypeUrl, data, this.httpOptions);
  }

  deleteRequestType(requestTypeId: number) {
    return this.http.delete(this.deleteRequestTypeUrl + requestTypeId);
  }

  getActiveRequestTypes() {
    return this.http.get(this.getRequestTypesActiveUrl, this.httpOptions);
  }

  getRecordsList() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getRequestTypesActiveUrl
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error(
            "Error in get request with service " + this.serviceName,
            error
          );
          return throwError(error);
        })
      );
  }

  getPublicRequestTypes() {
    return this.http.get(this.getRequestTypesPublicUrl, this.httpOptions);
  }

  changeStatusActive(id: number) {
    return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
  }

  changeStatusPublic(id: number) {
    return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
